import { useEffect, useState } from "react"
import type { SuccessFetch } from "../../../../../../types"
import { useApi } from "../../../../../../utils"  
import { DataList } from "pages/Setup/Preference/Module/types"

interface FilteredParams {
  page?: number
  keyword?: string
  limit?: number
}

interface DataType{
  payload: DataList[]
  pagination_data: {
    total: number
    page: number
    size: number
    pages: number
  }
}

export function useList({ page, keyword, limit }: FilteredParams) {

   // Vars
   const defaultValue = {
    payload: [],
    pagination_data: {
      page: 0,
      pages: 0,
      size: 0,
      total: 0
    }
  }

  const api = useApi()
  const [data, setData] = useState<DataType>(defaultValue)
  const [isLoading, setLoading] = useState(true)

  const params: { [key: string]: number | string | undefined } = {}
  if (page) params.page = page; 
  if (keyword) params.search = keyword; 
  if (limit) params.limit = limit; 
  
  const fetchUrl = () => {
      return api.get("/module/?only_active=false", {params})
  }

  const fetchData = () => {
    setLoading(true)

    fetchUrl()
    // .then((res: SuccessFetch<{ payload: DataType }>) => {
      .then((res: SuccessFetch<DataType>) => {
      setData(res.data)
    })
    .catch(() => {
      setData(defaultValue)
    }).finally(() => {
      setLoading(false)
    })
  }

  const refetch = () => fetchData()

  useEffect(() => {
    fetchData()

    return () => {
      setData(defaultValue)
      setLoading(true)
    }

    // eslint-disable-next-line
  }, [page, keyword, limit])

  return { data, isLoading, refetch }
}


export function useCode() {
  const api = useApi()
  const [dataCode, setDataCode] = useState<string | null>(null)
  const [isLoading, setLoading] = useState(true)

  useEffect(() => {
    const fetchData = () => api.get("/module/generate-code")

    fetchData().then((res: SuccessFetch<{
      payload: {
        next_code: string
      }
    }>) => {
      setDataCode(res.data.payload.next_code)
    }).catch(() => {
      setDataCode(null)
    }).finally(() => {
      setLoading(false)
    })

    return () => {
      setDataCode(dataCode)
      setLoading(true)
    }

    // eslint-disable-next-line
  }, [])

  return { dataCode, isLoading, setDataCode }
}